import React, { memo } from "react";
import Chart from "react-apexcharts";

function SparlLineBar({ id, series, labels, height = 35 }) {
  const chartOptions = {
    series: [
      {
        data: series || [],
      },
    ],
    options: {
      chart: {
        type: "bar",
        width: 100,
        height: 35,
        sparkline: {
          enabled: true,
        },
      },
      plotOptions: {
        bar: {
          columnWidth: "80%",
          colors: {
            ranges: [
              {
                from: 0,
                to: 0,
                color: "#f8f8f8",
              },
              {
                from: 0.1,
                to: Infinity,
                color: "#13388c",
              },
            ],
            backgroundBarColors: ["#F8F8F8"],
          },
        },
      },
      colors: ["#13388c"],
      labels: labels || [],
      xaxis: {
        crosshairs: {
          width: 1,
        },
      },
      tooltip: {
        fixed: {
          enabled: false,
        },
        x: {
          show: false,
        },
        y: {
          title: {
            formatter: function (seriesName) {
              return "";
            },
          },
        },
        marker: {
          show: false,
        },
      },
    },
  };

  return (
    <div id="chart-5" key={id}>
      <Chart
        options={chartOptions.options}
        series={chartOptions.series}
        type="bar"
        height={height}
        width={100}
      />
    </div>
  );
}

export default memo(SparlLineBar);
